'use client';

import { c as _c } from "react/compiler-runtime";
import { DOPLink } from '@/uiComposites/interactive/DOPLink';
import { callToAction } from '@/uiComposites/interactive/callToAction';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { box } from '@/uiPrimitives/layout/box';
import { position } from '@/uiPrimitives/layout/position';
import { stack } from '@/uiPrimitives/layout/stack';
import { zIndex } from '@/uiPrimitives/layout/zIndex.css';
import { hiddenAccessibleUnlessFocused } from '@/uiPrimitives/utility/display.css';
import { pointerEventsAuto, pointerEventsNone } from '@/uiPrimitives/utility/pointerEvents.css';
import { addTestSelector } from '@/globals/testHelpers/testSelector';
import { contentID } from './A11YSkipLinks.config';
import { translateInline } from '@/globals/translate/translateInline';
import { useIsInertBecauseOfMenu } from '../pageHeader/mainMenu/MainMenu.client';
import { usePathname } from 'next/navigation';
import { searchPath } from '@/globals/config/localization.config';
export const A11YSkipLinks = () => {
  const $ = _c(11);
  const inert = useIsInertBecauseOfMenu();
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    t0 = pathname.startsWith(searchPath);
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isSearchPage = t0;
  let t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classes(position({
      position: "absolute",
      insetBlockStart: "0",
      insetInline: "0"
    }), zIndex({
      zIndex: "skipLinks"
    }), stack({
      alignItems: "center"
    }), box({
      paddingBlockStart: "1 | h3"
    }), pointerEventsNone);
    t2 = addTestSelector("uiSkiplinks");
    t3 = classes(box({
      inlineSize: "fit-content"
    }));
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <li className={t3}><DOPLink href={`#${contentID}`} data-link-type="skipLink" className={classes(pointerEventsAuto, callToAction({}), hiddenAccessibleUnlessFocused)} {...addTestSelector("uiSkiplinkContent")}>{translateInline({
          en: "Skip to main content",
          nl: "Ga direct naar inhoud"
        })}</DOPLink></li>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== isSearchPage) {
    t5 = !isSearchPage && <li className={classes(box({
      inlineSize: "fit-content"
    }))}><DOPLink href={searchPath} data-link-type="skipLink" className={classes(pointerEventsAuto, callToAction({}), hiddenAccessibleUnlessFocused)} {...addTestSelector("uiSkiplinkSearch")}>{translateInline({
          en: "Go to the search page",
          nl: "Ga naar de zoeken pagina"
        })}</DOPLink></li>;
    $[6] = isSearchPage;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== inert || $[9] !== t5) {
    t6 = <ul inert={inert} className={t1} {...t2}>{t4}{t5}</ul>;
    $[8] = inert;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};